export default "__VITE_ASSET__jG0VHkBi__";